import { SnackbarComponent } from './snackbar/snackbar.component';
import { SnackbarActionComponent } from './snackbar-action/snackbar-action.component';

export const components: any[] = [
  SnackbarComponent,
  SnackbarActionComponent,
];

export const publicComponents: any[] = [
  SnackbarComponent,
];

export { SnackbarComponent } from './snackbar/snackbar.component';
export { SnackbarActionComponent } from './snackbar-action/snackbar-action.component';
